<template>
    <span class="inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ring-1 ring-inset" v-bind:class="ticket_status_class">{{ status }}</span>
</template>

<script>
import { computed } from 'vue'

export default {
    props: ['status'],
    setup(props) {
        const ticket_status_class = computed(() => {
            switch (props.status) {
                case 'received':
                    return 'bg-blue-50 text-blue-700 ring-blue-700/10'
                case 'awaiting information':
                case 'blocked':
                    return 'bg-red-50 text-red-700 ring-red-600/10'
                case 'in progress':
                    return 'bg-green-50 text-green-700 ring-green-600/20'
                case 'resolved':
                case 'cancelled':
                case 'archived':
                default:
                    return 'bg-gray-50 text-gray-700 ring-gray-500/10'
            }
        })

        return {
            ticket_status_class
        }
    }
}
</script>